import AnimateHeight from 'react-animate-height'

export default ({ children, width, ...props }) => (
  <AnimateHeight {...props} style={{ width: width || '100%' }}>
    {children}
  </AnimateHeight>
)
